import script from "./DeckList.vue?vue&type=script&setup=true&lang=js"
export * from "./DeckList.vue?vue&type=script&setup=true&lang=js"

import "./DeckList.vue?vue&type=style&index=0&id=8c16c4d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c16c4d4"]])

export default __exports__